import {Divider, Space, Stack, Text} from '@mantine/core';
import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import TagSchemaValidationSettings from 'settings/registry/TagSchemaValidationSettings';
import {updateTagSchemaValidationRules} from 'tag-schema/TagSchemaDAO';
import ValidationRulesTable from 'validation_rules/components/ValidationRulesTable';

export interface Props {
  tagSchemaId: string;
}

export default function TagSchemaValidationManagement(props: Props): JSX.Element | null {
  return (
    <div role="region" aria-label="Tag schema validation management">
      <Stack className="settingsPage-contentWrapper">
        <Stack spacing="sm" justify="flex-start">
          <Text size="xl">Validation rules</Text>
          <Text size="md">
            Entities created from this schema must follow these rules. Rules can include conditional logic and
            reference multiple fields, including fields on linked objects.
          </Text>
        </Stack>
        <ValidationRulesTable
          hasValidationRulesItemId={props.tagSchemaId}
          onSubmit={updateTagSchemaValidationRules}
        />
        {BenchlingConfig.REGISTRY_ENABLE_ASYNC_VALIDATION_SETTINGS_TAB && (
          <>
            <Space h="sm" />
            <Divider my="md" />
            <Stack spacing="sm" justify="flex-start">
              <Text size="xl">Validation failures</Text>
              <Text size="md">
                Entities linked here are in violation of at least one rule or other requirement.
              </Text>
            </Stack>
          </>
        )}
      </Stack>
      {BenchlingConfig.REGISTRY_ENABLE_ASYNC_VALIDATION_SETTINGS_TAB && (
        <TagSchemaValidationSettings tagSchemaId={props.tagSchemaId} />
      )}
    </div>
  );
}
